<template>
  <v-layout
    :class="[
      { 'white pa-3 justify-center row fill-height': background },
      { 'align-center': background && !xsOnly }
    ]"
  >
    <v-flex :class="[{ 'mt-3': !background }, { white: background }]">
      <v-layout
        row
        align-end
        fill-height
        :class="{ wrap: xsOnly }"
      >
        <v-flex
          shrink
          :class="[{ 'xs12 order-xs3': xsOnly }, { 'mt-4': xsOnly && background }]"
        >
          <v-layout :class="[{ 'justify-space-between size-12 mt-2': xsOnly }]">
            <v-flex
              shrink
              :class="[{ 'mr-3': !xsOnly }, { 'mr-1': +xsOnly }]"
            >
              <p class="ma-0">
                {{ $t('message.copyrights', { year: currentYear }) }}
              </p>
            </v-flex>
            <v-flex
              shrink
              :class="[{ 'mr-3': !xsOnly }, { 'mr-1': +xsOnly }]"
            >
              <a
                :class="{ 'size-14': !xsOnly }"
                target="_blank"
                :href="links.TERMS_OF_SERVICE"
              >
                {{ $t('helps.terms_of_service') }}
              </a>
            </v-flex>
            <v-flex shrink>
              <a
                :class="{ 'size-14': !xsOnly }"
                target="_blank"
                :href="links.PRIVACY_POLICY"
              >
                {{ $t('helps.privacy_policy') }}
              </a>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-spacer />
        <v-flex
          shrink
          :class="[{ 'xs12 order-xs1': xsOnly }]"
        >
          <v-layout :class="{ wrap: xsOnly }">
            <v-flex
              shrink
              :class="[{ 'xs12 text-xs-center': xsOnly }]"
            >
              <a
                class="size-14"
                target="_blank"
                :href="links.SZP"
              >{{ $t('helps.SZP') }}</a>
            </v-flex>
            <v-flex :class="[{ 'mx-3': !xsOnly }, { 'd-none': xsOnly }]">
              <v-divider vertical />
            </v-flex>
            <v-flex
              shrink
              :class="{ 'xs12 text-xs-center mt-2': xsOnly }"
            >
              <a
                class="size-14"
                target="_blank"
                href="https://moja.wiosna.org.pl/logowanie"
              >{{
                $t('helps.MW')
              }}</a>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-spacer />
        <v-flex
          shrink
          :class="{ 'xs12 order-xs2 mt-2': xsOnly }"
        >
          <v-layout
            align-center
            justify-center
            row
          >
            <v-flex
              shrink
              mr-3
            >
              <a
                class="size-14 fill-height"
                target="_blank"
                href="https://www.facebook.com/szlachetna.paczka"
              ><BaseIcon><fbIcon /></BaseIcon></a>
            </v-flex>
            <v-flex
              shrink
              mr-3
            >
              <a
                class="size-14 fill-height"
                target="_blank"
                href="https://www.instagram.com/szlachetnapaczka"
              ><BaseIcon><instagramIcon /></BaseIcon></a>
            </v-flex>
            <v-flex shrink>
              <a
                class="size-14 fill-height"
                target="_blank"
                href="https://www.youtube.com/user/paczkaTV"
              ><BaseIcon><youtubeIcon /></BaseIcon></a>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import BaseIcon from '@/icons/BaseIcon';
import fbIcon from '@/icons/fbIcon';
import instagramIcon from '@/icons/instagramIcon';
import youtubeIcon from '@/icons/youtubeIcon';

import links from '@/constants/links';

export default {
    name: 'AppFooter',
    components: { BaseIcon, fbIcon, instagramIcon, youtubeIcon },
    props: {
        background: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            links,
            currentYear: new Date().getFullYear()
        };
    },
    computed: {
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        featuresVisible () {
            return this.$store.getters.featuresVisible;
        }
    }
};
</script>

<style lang="scss" scoped>
.size-14 {
  font-size: 14px;
}
a.fill-height {
  height: 25px;
  display: block;
}
.size-12 {
  p,
  a {
    font-size: 12px;
  }
}
</style>
